"use strict";;define(function(require,exports,module){const Vue = require('vue');
const $   = require('jquery');
const _   = require('lodash');

const windowSize = {};

/**
 * This utility returns the current window inner dimensions and is observable.
 */
Vue.util.windowSize = function() {
	if (!_.isEmpty(windowSize)) {
		return {
			width  : windowSize.width,
			height : windowSize.height,
		};
	}

	// Define the reactive property on our storage object
	Vue.util.defineReactive(windowSize, 'width', window.innerWidth);
	Vue.util.defineReactive(windowSize, 'height', window.innerHeight);

	function updateWindowSize() {
		windowSize.width  = window.innerWidth;
		windowSize.height = window.innerHeight;
	}

	$(window).on('resize', _.debounce(updateWindowSize, 100));

	updateWindowSize();

	// touch the new reactive fields & return their value
	return {
		width  : windowSize.width,
		height : windowSize.height,
	};
};

});